@if (journey && productGroup) {
<div class="pdf-preview-proof-page">
  <div class="header__new">
    <div class="header__top__new">
      <h1 class="header__title__new" id="journey-name">
        {{ journey?.latestContent?.name }}
      </h1>
      <div class="header__buttons__new">
        <button
          id="edit-mode-btn"
          class="btn btn-primary"
          (click)="toggleEditMode()"
        >
          {{ editMode ? 'Disable Content Edit' : 'Enable Content Edit' }}
        </button>
        @if (showAdditionalScreensButton) {
        <button
          id="pdf-btn"
          class="btn btn-primary"
          (click)="chooseAdditionalScreens()"
          [disabled]="this.pdfPreviewIsBusy"
        >
          Choose additional screens
        </button>
        }
        <button
          id="pdf-btn"
          class="btn btn-primary"
          (click)="requestPdf()"
          [disabled]="this.pdfPreviewIsBusy"
        >
          Download PDF
        </button>
      </div>
    </div>
    <p class="header__text__new">
      This is your PDF proof. By enabling Content Edit you can make changes to
      the text below, which will appear ONLY in your final PDF.
    </p>

    @if (previewMode === 'collapsed') {
    <p class="header__text__new">
      This PDF is optimized for printing and will not export to show Feed
      content in its entirety. You can
      <span class="link__to__preview" (click)="viewExpandedPreview()"
        >view an Expanded PDF here</span
      >.
    </p>
    } @if (previewMode === 'expanded') {
    <p class="header__text__new">
      This PDF is formatted to show feed content in its entirety and is not
      optimized for printing. You can
      <span class="link__to__preview" (click)="viewCollapsedPreview()"
        >view a Print-ready PDF here</span
      >.
    </p>
    }
  </div>
  @if (editMode) {
  <div class="edit-mode-message">
    Text is now Editable. Click on any text to edit it before generating your
    PDF. These changes cannot be saved, but will appear in generated PDFs.
  </div>
  }
  <div class="journey-pdf-preview-wrapper">
    <div id="journey-pdf-preview">
      @if (previewMode === 'expanded') {
      <div class="metadata">
        <div class="metadata--content">
          @if (journeyContent.product_group_name) {
          <div class="metadata--item">
            <span i18n="Experience product group label">Product Group: </span>
            <span id="product-group-name">{{
              journeyContent.product_group_name
            }}</span>
          </div>
          } @if (journeyContent.campaign) {
          <div class="metadata--item">
            <span>Campaign: </span>
            <span>{{ journeyContent.campaign }}</span>
          </div>
          } @if (journey.created_at) {
          <div class="metadata--item">
            <span>Date Created: </span>
            <span>{{ journey.created_at | date: 'shortDate' }}</span>
          </div>
          } @if (journey.updated_at) {
          <div class="metadata--item">
            <span>Date Modified: </span>
            <span>{{ journey.updated_at | date: 'shortDate' }}</span>
          </div>
          } @if (journey.created_by_name) {
          <div class="metadata--item">
            <span>Created By: </span>
            <span>{{ journey.created_by_name }}</span>
          </div>
          }
        </div>
        <div class="journey-pdf-toc my-0 mx-auto pt-4">
          <h2 class="m-0">{{ journeyContent.name }}</h2>
          <ol class="anchor-list mb-0">
            @for (anchor of pageAnchors; track anchor) {
            <li [ngClass]="{ 'indent-anchor': anchor.isWorkFlowDelayer }">
              <a
                class="toc-preview-only"
                [routerLink]="[]"
                (click)="goToPageId(anchor.pageId)"
                >{{
                  anchor.step ? anchor.step + ': ' + anchor.title : anchor.title
                }}</a
              >
              <a class="toc-print-only" href="#{{ anchor.pageId }}">{{
                anchor.step ? anchor.step + ': ' + anchor.title : anchor.title
              }}</a>
            </li>
            }
            <!-- Anchor for additional screens -->
            @for (additionalScreen of additionalScreens; track additionalScreen)
            {
            <!-- Only show selected screens -->
            @if (additionalScreen.selected) {
            <li>
              <a
                class="toc-preview-only"
                [routerLink]="[]"
                (click)="goToPageId(additionalScreen.id)"
                >{{ additionalScreen.previewTitle }}</a
              >
              <a class="toc-print-only" href="#{{ additionalScreen.id }}">{{
                additionalScreen.previewTitle
              }}</a>
            </li>
            } }
          </ol>
        </div>
        <!-- This empty div is to block metadata from being editted -->
        @if (editMode) {
        <div class="metadata--background"></div>
        }
      </div>
      }
      <ul class="document">
        @for (page of pages; track page; let pageNumber = $index) {
        <li class="page">
          <h2 class="page__title" id="{{ getPDFPageId(page, pageNumber) }}">
            {{ page.title }}
          </h2>
          <div class="page__trigger_ids">
            @if (page.triggerId) {
            <p><span>Trigger ID: </span>{{ page.triggerId }}</p>
            } @if (page.clientTriggerId) {
            <p><span>Client Trigger ID: </span>{{ page.clientTriggerId }}</p>
            }
          </div>
          <div
            class="page__previews-group"
            [class.page--expanded-view]="previewMode === 'expanded'"
          >
            @for ( message of page.messagePreviews; track message; let
            phoneIndex = $index) { @if (isSmsMessage(message)) { @if
            (isSmsMessage(message)) {
            <div class="phone" [id]="'sms--' + message.name">
              <h3>SMS {{ message.step }}</h3>
              <phone
                [productGroup]="productGroup"
                [message]="message"
                [screen]="'sms'"
                [large]="true"
                [components]="journeyContent.components"
                [previewMode]="previewMode"
                [language]="journey.latestContent.language"
              ></phone>
            </div>
            } @if (isDisplayableWireMessage(message)) {
            <journey-arrow [arrowType]="'straight-right'"></journey-arrow>
            } } @if (isDisplayableWireMessage(message)) {
            <div class="phone" [id]="'message--' + message.name">
              <h3>{{ message.step || message.label }}</h3>
              @if (message.type !== 'form_info_capture') {
              <phone
                [message]="message"
                [screen]="'wire'"
                [productGroup]="productGroup"
                [large]="true"
                [showPdfMarkup]="true"
                [components]="journeyContent.components"
                [stretch]="previewMode === 'expanded'"
                [previewMode]="previewMode"
                [language]="journey.latestContent.language"
              ></phone>
              } @if (message.type === 'form_info_capture') {
              <phone
                [message]="message"
                [screen]="'form'"
                [productGroup]="productGroup"
                [large]="true"
                [showPdfMarkup]="true"
                [components]="journeyContent.components"
                [stretch]="previewMode === 'expanded'"
                [previewMode]="previewMode"
                [language]="journey.latestContent.language"
              ></phone>
              }
            </div>
            } @if (phoneIndex < page.messagePreviews.length - 1) {
            <journey-arrow [arrowType]="'straight-right'"></journey-arrow>
            } }
          </div>
          <div class="page__footer">
            <div class="page__details-group">
              @for ( message of page.messagePreviews; track message; let
              phoneIndex = $index) { @if (isSmsMessage(message)) {
              <div class="page__detail"></div>
              } @if (isDisplayableWireMessage(message)) {
              <div class="page__detail">
                <ol class="page__detail_actions">
                  @for (action of message?.wire?.actions; track action) {
                  <li>
                    @if (action.type !== 'two_way') {
                    <span [innerHtml]="actionDetailText(action)"></span>
                    } @if (action.type === 'two_way') {
                    <span
                      [innerHtml]="twoWayActionDetailText(action) | async"
                    ></span>
                    }
                  </li>
                  }
                </ol>
              </div>
              } }
            </div>
          </div>
          @if (previewMode === 'collapsed') {
          <div class="page__metadata">
            @if (journeyContent.product_group_name) {
            <div class="page__metadata-item">
              <span i18n="Experience product group label">Product Group: </span>
              <span id="product-group-name">{{
                journeyContent.product_group_name
              }}</span>
            </div>
            } @if (journeyContent.campaign) {
            <div class="page__metadata-item">
              <span>Campaign: </span>
              <span>{{ journeyContent.campaign }}</span>
            </div>
            } @if (journey.created_at) {
            <div class="page__metadata-item">
              <span>Date Created: </span>
              <span>{{ journey.created_at | date: 'shortDate' }}</span>
            </div>
            } @if (journey.updated_at) {
            <div class="page__metadata-item">
              <span>Date Modified: </span>
              <span>{{ journey.updated_at | date: 'shortDate' }}</span>
            </div>
            } @if (journey.created_by_name) {
            <div class="page__metadata-item">
              <span>Created By: </span>
              <span>{{ journey.created_by_name }}</span>
            </div>
            } @if (journey.created_by_name) {
            <div class="page__metadata-item">
              <span>Page: </span>
              <span>{{ pageNumber + 1 }} of {{ pages.length }}</span>
            </div>
            }
          </div>
          }
          <div class="page__background"></div>
        </li>
        }
        <!-- Additional Screens  -->
        @for (additionalScreen of additionalScreens; track additionalScreen) {
        <!-- Only show selected screens -->
        @if (additionalScreen.selected) {
        <!-- Show SMS Auto Responses Screen -->
        @if (additionalScreen.id === 'sms-auto-responses-screen') {
        <li class="page additional-screen-page">
          <div
            class="page__previews-group additional-screen"
            [class.page--expanded-view]="previewMode === 'expanded'"
          >
            <h2
              class="page__title additional-screen"
              [id]="additionalScreen.id"
            >
              {{ additionalScreen.previewTitle }}
            </h2>
            <div class="page__additional_screen-previews">
              @for (response of smsAutoResponses; track response) {
              <div class="phone" [id]="'sms-auto-response-' + response.title">
                <h3>{{ response.title }}</h3>
                <phone
                  [message]="response.message"
                  [screen]="'sms'"
                  [large]="true"
                  [showPdfMarkup]="true"
                  [previewMode]="previewMode"
                ></phone>
              </div>
              }
            </div>
          </div>
        </li>
        }
        <!-- Show About Relay Screen -->
        @if (additionalScreen.id === 'about-menu-items-screen') {
        <li class="page additional-screen-page">
          <div
            class="page__previews-group additional-screen"
            [class.page--expanded-view]="previewMode === 'expanded'"
          >
            <h2
              class="page__title additional-screen"
              [id]="additionalScreen.id"
            >
              {{ additionalScreen.previewTitle }}
            </h2>
            <p>This content is provided by Relay</p>
            <div class="page__additional_screen-previews">
              <div>
                <h3>About Relay</h3>
                <rn-generic-phone
                  [size]="'medium'"
                  [stretch]="previewMode === 'expanded'"
                >
                  <about-relay-preview-react
                    [showHamburger]="!productGroup.hide_hamburger"
                    [color]="productGroup.branding.color"
                  ></about-relay-preview-react>
                </rn-generic-phone>
              </div>
              <div>
                <h3>Privacy Policy</h3>
                <rn-generic-phone
                  [size]="'medium'"
                  [stretch]="previewMode === 'expanded'"
                >
                  <privacy-policy-preview-react
                    [showHamburger]="!productGroup.hide_hamburger"
                    [color]="productGroup.branding.color"
                  ></privacy-policy-preview-react>
                </rn-generic-phone>
              </div>
              <div>
                <h3>Terms and Conditions</h3>
                <rn-generic-phone
                  [size]="'medium'"
                  [stretch]="previewMode === 'expanded'"
                >
                  <terms-and-conditions-preview-react
                    [showHamburger]="!productGroup.hide_hamburger"
                    [color]="productGroup.branding.color"
                  ></terms-and-conditions-preview-react>
                </rn-generic-phone>
              </div>
            </div>
          </div>
        </li>
        <br />
        } @if (additionalScreen.id === 'feed-view-disclaimer-screen') { @if
        (firstDisplayableWireMessage) {
        <li class="page additional-screen-page">
          <div
            class="page__previews-group additional-screen"
            [class.page--expanded-view]="previewMode === 'expanded'"
          >
            <h2
              class="page__title additional-screen"
              [id]="additionalScreen.id"
            >
              {{ additionalScreen.title }}
            </h2>
            <p>
              This displays as a static dismissable area at the bottom of the
              feed view.
            </p>
            <div class="page__additional_screen-previews">
              <div class="phone" [id]="'feed-view-disclaimer'">
                <phone
                  [message]="firstDisplayableWireMessage"
                  [screen]="'wire'"
                  [showFeedViewDisclaimer]="true"
                  [productGroup]="productGroup"
                  [large]="true"
                  [showPdfMarkup]="true"
                  [components]="journeyContent.components"
                  [stretch]="previewMode === 'expanded'"
                  [previewMode]="previewMode"
                  [language]="journey.latestContent.language"
                ></phone>
              </div>
            </div>
          </div>
        </li>
        } } @if (additionalScreen.id === 'verification-screen') { @let props =
        verificationPreviewProps;
        <li class="page additional-screen-page">
          <div
            class="page__previews-group additional-screen"
            [class.page--expanded-view]="previewMode === 'expanded'"
          >
            <h2
              class="page__title additional-screen"
              [id]="additionalScreen.id"
            >
              {{ additionalScreen.title }}
            </h2>
            <div class="page__additional_screen-previews">
              <div class="phone" [id]="'verification-screen'">
                <rn-generic-phone
                  [size]="'medium'"
                  [stretch]="previewMode === 'expanded'"
                >
                  <rn-verification-preview
                    [preGated]="true"
                    [pswEnabled]="props.pswEnabled"
                    [pswTCS]="props.pswTCS"
                    [pswTCMandatory]="props.pswTCMandatory"
                    [consentTSCS]="props.consentTSCS"
                    [fields]="props.fields"
                    [logoUrl]="props.logoUrl"
                    [color]="props.color"
                    [productGroupName]="props.productGroupName"
                    [showProductGroup]="props.showProductGroup"
                    [productGroupDescription]="props.productGroupDescription"
                    [fdic]="props.fdic"
                    [showFdic]="props.showFdic"
                    [showBanner]="props.showBanner"
                    [bannerUrl]="props.bannerUrl"
                    [bannerAltText]="props.bannerAltText"
                    [showLogo]="props.showLogo"
                    [showTitleBar]="props.showTitleBar"
                    [verificationHeader]="props.verificationHeader"
                    [verificationBody]="props.verificationBody"
                    [verificationButtonLabel]="props.verificationButtonLabel"
                    [language]="props.language"
                    [i18nEs]="props.i18nEs"
                  ></rn-verification-preview>
                </rn-generic-phone>
              </div>
              @if (additionalScreen.includeErrorState) {
              <div class="phone" [id]="'verification-error-screen'">
                <rn-generic-phone
                  [size]="'medium'"
                  [stretch]="previewMode === 'expanded'"
                >
                  <rn-verification-preview
                    [preGated]="true"
                    [postVerificationError]="true"
                    [pswEnabled]="props.pswEnabled"
                    [pswTCS]="props.pswTCS"
                    [pswTCMandatory]="props.pswTCMandatory"
                    [consentTSCS]="props.consentTSCS"
                    [fields]="props.fields"
                    [logoUrl]="props.logoUrl"
                    [color]="props.color"
                    [productGroupName]="props.productGroupName"
                    [showProductGroup]="props.showProductGroup"
                    [productGroupDescription]="props.productGroupDescription"
                    [fdic]="props.fdic"
                    [showFdic]="props.showFdic"
                    [showBanner]="props.showBanner"
                    [bannerUrl]="props.bannerUrl"
                    [bannerAltText]="props.bannerAltText"
                    [showLogo]="props.showLogo"
                    [showTitleBar]="props.showTitleBar"
                    [verificationHeader]="props.verificationHeader"
                    [verificationBody]="props.verificationBody"
                    [verificationButtonLabel]="props.verificationButtonLabel"
                    [language]="props.language"
                    [i18nEs]="props.i18nEs"
                  ></rn-verification-preview>
                </rn-generic-phone>
              </div>
              }
            </div>
          </div>
        </li>
        <br />
        } @if (additionalScreen.id === 'password-pages-screen') { @let
        pswProps = passwordPagesPreviewProps;
        <li class="page additional-screen-page">
          <div
            class="page__previews-group additional-screen"
            [class.page--expanded-view]="previewMode === 'expanded'"
          >
            <h2
              class="page__title additional-screen"
              [id]="additionalScreen.id"
            >
              {{ additionalScreen.title }}
            </h2>
            <div class="page__additional_screen-previews">
              <div class="phone" [id]="'password-pages-create'">
                <h3>Create</h3>
                <rn-generic-phone
                  [size]="'medium'"
                  [stretch]="previewMode === 'expanded'"
                >
                  <set-password-page-preview-react
                    [pswMessageText]="pswProps.pswMessageText"
                    [pswButtonLabel]="pswProps.pswButtonLabel"
                    [pswTCS]="pswProps.pswTCS"
                    [pswTCMandatory]="pswProps.pswTCMandatory"
                    [logoUrl]="pswProps.logoUrl"
                    [color]="pswProps.color"
                    [productGroupName]="pswProps.productGroupName"
                    [showProductGroup]="pswProps.showProductGroup"
                    [productGroupDescription]="pswProps.productGroupDescription"
                    [fdic]="pswProps.fdic"
                    [showFdic]="pswProps.showFdic"
                    [showLogo]="pswProps.showLogo"
                    [showTitleBar]="pswProps.showTitleBar"
                    [consentContent]="pswProps.consentContent"
                    [language]="pswProps.language"
                    [i18nEs]="pswProps.i18nEs"
                  ></set-password-page-preview-react>
                </rn-generic-phone>
              </div>
              <div class="phone" [id]="'password-pages-login'">
                <h3>Log In</h3>
                <rn-generic-phone
                  [size]="'medium'"
                  [stretch]="previewMode === 'expanded'"
                >
                  <rn-password-page-preview
                    [screen]="'login'"
                    [logoUrl]="pswProps.logoUrl"
                    [color]="pswProps.color"
                    [productGroupName]="pswProps.productGroupName"
                    [showProductGroup]="pswProps.showProductGroup"
                    [productGroupDescription]="pswProps.productGroupDescription"
                    [fdic]="pswProps.fdic"
                    [showFdic]="pswProps.showFdic"
                    [showLogo]="pswProps.showLogo"
                    [showTitleBar]="pswProps.showTitleBar"
                    [language]="pswProps.language"
                  ></rn-password-page-preview>
                </rn-generic-phone>
              </div>
              <div class="phone" [id]="'password-pages-change'">
                <h3>Change</h3>
                <rn-generic-phone
                  [size]="'medium'"
                  [stretch]="previewMode === 'expanded'"
                >
                  <rn-password-page-preview
                    [screen]="'change'"
                    [logoUrl]="pswProps.logoUrl"
                    [color]="pswProps.color"
                    [productGroupName]="pswProps.productGroupName"
                    [showProductGroup]="pswProps.showProductGroup"
                    [productGroupDescription]="pswProps.productGroupDescription"
                    [fdic]="pswProps.fdic"
                    [showFdic]="pswProps.showFdic"
                    [showLogo]="pswProps.showLogo"
                    [showTitleBar]="pswProps.showTitleBar"
                    [language]="pswProps.language"
                  ></rn-password-page-preview>
                </rn-generic-phone>
              </div>
              <div class="phone" [id]="'password-pages-forgot'">
                <h3>Forgot</h3>
                <rn-generic-phone
                  [size]="'medium'"
                  [stretch]="previewMode === 'expanded'"
                >
                  <rn-password-page-preview
                    [screen]="'forgot'"
                    [logoUrl]="pswProps.logoUrl"
                    [color]="pswProps.color"
                    [productGroupName]="pswProps.productGroupName"
                    [showProductGroup]="pswProps.showProductGroup"
                    [productGroupDescription]="pswProps.productGroupDescription"
                    [fdic]="pswProps.fdic"
                    [showFdic]="pswProps.showFdic"
                    [showLogo]="pswProps.showLogo"
                    [showTitleBar]="pswProps.showTitleBar"
                    [language]="pswProps.language"
                  ></rn-password-page-preview>
                </rn-generic-phone>
              </div>
              @if (additionalScreen.includeErrorState) {
              <div class="phone" [id]="'password-pages-create-error'">
                <h3>Create (errors)</h3>
                <rn-generic-phone
                  [size]="'medium'"
                  [stretch]="previewMode === 'expanded'"
                >
                  <set-password-page-preview-react
                    [isError]="true"
                    [pswMessageText]="pswProps.pswMessageText"
                    [pswButtonLabel]="pswProps.pswButtonLabel"
                    [pswTCS]="pswProps.pswTCS"
                    [pswTCMandatory]="pswProps.pswTCMandatory"
                    [logoUrl]="pswProps.logoUrl"
                    [color]="pswProps.color"
                    [productGroupName]="pswProps.productGroupName"
                    [showProductGroup]="pswProps.showProductGroup"
                    [productGroupDescription]="pswProps.productGroupDescription"
                    [fdic]="pswProps.fdic"
                    [showFdic]="pswProps.showFdic"
                    [showLogo]="pswProps.showLogo"
                    [showTitleBar]="pswProps.showTitleBar"
                    [consentContent]="pswProps.consentContent"
                    [language]="pswProps.language"
                    [i18nEs]="pswProps.i18nEs"
                  ></set-password-page-preview-react>
                </rn-generic-phone>
              </div>
              <div class="phone" [id]="'password-pages-login-error'">
                <h3>Log In (errors)</h3>
                <rn-generic-phone
                  [size]="'medium'"
                  [stretch]="previewMode === 'expanded'"
                >
                  <rn-password-page-preview
                    [screen]="'login'"
                    [isError]="true"
                    [logoUrl]="pswProps.logoUrl"
                    [color]="pswProps.color"
                    [productGroupName]="pswProps.productGroupName"
                    [showProductGroup]="pswProps.showProductGroup"
                    [productGroupDescription]="pswProps.productGroupDescription"
                    [fdic]="pswProps.fdic"
                    [showFdic]="pswProps.showFdic"
                    [showLogo]="pswProps.showLogo"
                    [showTitleBar]="pswProps.showTitleBar"
                    [language]="pswProps.language"
                  ></rn-password-page-preview>
                </rn-generic-phone>
              </div>
              <div class="phone" [id]="'password-pages-change-error'">
                <h3>Change (errors)</h3>
                <rn-generic-phone
                  [size]="'medium'"
                  [stretch]="previewMode === 'expanded'"
                >
                  <rn-password-page-preview
                    [screen]="'change'"
                    [isError]="true"
                    [logoUrl]="pswProps.logoUrl"
                    [color]="pswProps.color"
                    [productGroupName]="pswProps.productGroupName"
                    [showProductGroup]="pswProps.showProductGroup"
                    [productGroupDescription]="pswProps.productGroupDescription"
                    [fdic]="pswProps.fdic"
                    [showFdic]="pswProps.showFdic"
                    [showLogo]="pswProps.showLogo"
                    [showTitleBar]="pswProps.showTitleBar"
                    [language]="pswProps.language"
                  ></rn-password-page-preview>
                </rn-generic-phone>
              </div>
              <div class="phone" [id]="'password-pages-forgot-error'">
                <h3>Forgot (errors)</h3>
                <rn-generic-phone
                  [size]="'medium'"
                  [stretch]="previewMode === 'expanded'"
                >
                  <rn-password-page-preview
                    [screen]="'forgot'"
                    [isError]="true"
                    [logoUrl]="pswProps.logoUrl"
                    [color]="pswProps.color"
                    [productGroupName]="pswProps.productGroupName"
                    [showProductGroup]="pswProps.showProductGroup"
                    [productGroupDescription]="pswProps.productGroupDescription"
                    [fdic]="pswProps.fdic"
                    [showFdic]="pswProps.showFdic"
                    [showLogo]="pswProps.showLogo"
                    [showTitleBar]="pswProps.showTitleBar"
                    [language]="pswProps.language"
                  ></rn-password-page-preview>
                </rn-generic-phone>
              </div>
              }
            </div>
          </div>
        </li>
        <br />
        }
        <!-- TODO: Add other additional screens here -->

        } }
      </ul>
    </div>
  </div>
</div>
}

<message-dialog #messageDialogProgress [showAffirm]="false"></message-dialog>
<message-dialog #messageDialogError (affirm)="closeDialog()"></message-dialog>
<app-screen-selection-dialog
  #screenSelectionDialog
  [screens]="additionalScreens"
  [maxSelections]="5"
  title="Include Additional Screens in PDF export"
  (confirmed)="onScreensSelected($event)"
>
</app-screen-selection-dialog>
<rn-timer-popup></rn-timer-popup>
